export default "__VITE_ASSET__y7sYstal__"